export const DOWNLOAD_REPORT_FAILURE = 'DOWNLOAD_REPORT_FAILURE';

export const downloadReportFailure = error => ({
    type: DOWNLOAD_REPORT_FAILURE,
    payload: error,
    error: true,
});
